import { render, staticRenderFns } from "./InputCheckboxOld.vue?vue&type=template&id=a4bf63e2&"
import script from "./InputCheckboxOld.vue?vue&type=script&lang=js&"
export * from "./InputCheckboxOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports